import { IUpdateMode, IPaginatedREST } from '../types'
import { BOWTIE_BASE_URL, BOWTIE_REST_ENDPOINTS } from '../utils/constants'

export const listUpdateModes = async (): Promise<IUpdateMode[]> => {
    const qs = new URLSearchParams({}).toString()

    return fetch(`${BOWTIE_BASE_URL}/${BOWTIE_REST_ENDPOINTS.updateMode}/?${qs}`, {
        method: 'GET',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' }
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {
            return jsonData
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message)
        }
    })
}

interface IUpdateModeMethodsResponse {
    method?: string
    id: number
}
export const getUpdateModeMethods = async (): Promise<IPaginatedREST<IUpdateModeMethodsResponse>> => {
    // const qs = new URLSearchParams({}).toString()

    return fetch(`${BOWTIE_BASE_URL}/${BOWTIE_REST_ENDPOINTS.updateModeMethods}/`, {
        method: 'GET',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' }
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {
            return jsonData
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message)
        }
    })
}
